import React from 'react';
import icon_bundle from './icons-bundle.svg';
import './icons-bundle.css';

class IconComponent extends React.Component {
  render() {
    const { active, icon } = this.props;
    if (!icon) {
      return null;
    }
    return (
        <svg className={`icon icons_${icon} ${(active) ? 'active' : ''} ${this.props.className || ''}`} >
            <use xlinkHref={`${icon_bundle}#${icon}`} />
        </svg>
    );
  }
}

export { IconComponent };
